import { z } from 'zod';
import { LocaleSchema } from '~/plugins/i18n/_types';
import { zDbId } from '~/plugins/zod/utils';
import { LocalizedValueSchema } from '../links/_types';

export const TranslationGroupInfoSchema = z.object({
    Group: z.string(),
});

export const TranslationInfoSchema = z.object({
    Id: zDbId(),
    Group: z.string(),
    Key: z.string(),
    Text: LocalizedValueSchema,
});

export const TranslationFormDataSchema = z.object({
    Text: z.record(LocaleSchema, z.string()),
});

export const FetchTranslationsResponseSchema = TranslationInfoSchema.array();
export const FetchTranslationGroupsResponseSchema = TranslationGroupInfoSchema.array();

export type TranslationInfo = z.infer<typeof TranslationInfoSchema>;
export type TranslationGroupInfo = z.infer<typeof TranslationInfoSchema>;
export type TranslationFormData = z.infer<typeof TranslationFormDataSchema>;
export type FetchTranslationsResponse = z.infer<typeof FetchTranslationsResponseSchema>;
export type FetchTranslationGroupsResponse = z.infer<typeof FetchTranslationGroupsResponseSchema>;
